var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9256 39.7285C26.2733 39.7285 33.8512 32.1506 33.8512 22.8029C33.8512 13.4552 26.2733 5.87732 16.9256 5.87732C7.57784 5.87732 0 13.4552 0 22.8029C0 32.1506 7.57784 39.7285 16.9256 39.7285Z",
    fill: "#B0EF8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1167 35.8853L16.902 35.5195C13.6228 29.9323 4.90855 18.0753 4.82053 17.9562L4.69482 17.7855L7.6637 14.8514L17.0616 21.4137C22.9787 13.7353 28.499 8.46144 32.0998 5.38172C36.0389 2.01281 38.6029 0.461874 38.6288 0.447012L38.6871 0.412109H43.7232L43.2421 0.840523C30.8702 11.8602 17.4603 35.2814 17.3268 35.5167L17.1167 35.8853Z",
    fill: "#009045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectAnswer);
export default __webpack_public_path__ + "static/media/correctAnswer.b19b6dc6bbf053683b3e6718b62f8c3a.svg";
export { ForwardRef as ReactComponent };